/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Resume_Build_ScratchInputs */

const en_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build From Scratch`)
};

const de_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von Grund auf neu erstellen`)
};

const fr_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un CV à partir de zéro`)
};

const es_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear desde cero`)
};

const it_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea da Zero`)
};

const nl_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak van scratch`)
};

const pl_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz od podstaw`)
};

const fi_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakentaa Alusta Alkaen`)
};

const da_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret fra bunden`)
};

const sv_onboarding_resume_build_scratch = /** @type {(inputs: Onboarding_Resume_Build_ScratchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa från grunden`)
};

/**
* | output |
* | --- |
* | "Build From Scratch" |
*
* @param {Onboarding_Resume_Build_ScratchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_build_scratch = /** @type {((inputs?: Onboarding_Resume_Build_ScratchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_Build_ScratchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_build_scratch(inputs)
	if (locale === "fr") return fr_onboarding_resume_build_scratch(inputs)
	if (locale === "es") return es_onboarding_resume_build_scratch(inputs)
	if (locale === "it") return it_onboarding_resume_build_scratch(inputs)
	if (locale === "nl") return nl_onboarding_resume_build_scratch(inputs)
	if (locale === "pl") return pl_onboarding_resume_build_scratch(inputs)
	if (locale === "fi") return fi_onboarding_resume_build_scratch(inputs)
	if (locale === "da") return da_onboarding_resume_build_scratch(inputs)
	if (locale === "sv") return sv_onboarding_resume_build_scratch(inputs)
	return en_onboarding_resume_build_scratch(inputs)
});